"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LegitimateInterestLegalBasis = exports.ProcessingConsentType = exports.LegalConsentOptions = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var LegalConsentOptions = (0, _keyMirror.default)({
  NONE: null,
  IMPLICIT_CONSENT: null,
  SEPERATE_CONSENT: null,
  LEGITIMATE_INTEREST: null
});
exports.LegalConsentOptions = LegalConsentOptions;
var ProcessingConsentType = (0, _keyMirror.default)({
  IMPLICIT: null,
  REQUIRED_CHECKBOX: null
});
exports.ProcessingConsentType = ProcessingConsentType;
var LegitimateInterestLegalBasis = (0, _keyMirror.default)({
  LEGITIMATE_INTEREST_PQL: null,
  LEGITIMATE_INTEREST_CLIENT: null,
  PERFORMANCE_OF_CONTRACT: null,
  CONSENT_WITH_NOTICE: null,
  NON_GDPR: null
});
exports.LegitimateInterestLegalBasis = LegitimateInterestLegalBasis;